module.exports = __webpack_public_path__ + "static/media/12.14b023a3.svg";